
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart_city",
      function () {
        return require("private-next-pages/smart_city/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart_city"])
      });
    }
  